import React, { useEffect, useState } from "react";
import { Card, Spinner, Alert } from "react-bootstrap";
import bookimg1 from "../../../assets/img/bookimg1.jpg";
import { userFollowerList } from "../../../api/userService";
import { useParams,Link } from "react-router-dom";
import DataTable from "react-data-table-component";

const MEDIA_URL = "https://d3bn54rc14fhr4.cloudfront.net";

export default function FollowersTab() {
  const { userId } = useParams();
  const [searchText, setSearchText] = useState("");
  const [userFollowerListData, setUserFollowerListData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [noData, setNoData] = useState(false);

  useEffect(() => {
    if (userId) {
      fetchUserFollower();
    }
  }, [userId]);

  const fetchUserFollower = async () => {
    setLoading(true);
    setError("");
    setNoData(false);

    try {
      const response = await userFollowerList({ userId });

      if (response?.data && response.data.length > 0) {
        const updatedData = response.data.map((item, index) => ({
          id: index + 1,
          _id: item?.follower?._id,
          fullName: item?.follower?.fullName || "-",
          username: item?.follower?.username || "-",
          email: item?.follower?.email || "-",
          profilePic: item?.follower?.profilePic,
          followedOn: new Date(item?.createdAt).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric"
          }),
        }));

        console.log('====5555555==updatedData',updatedData)

        setUserFollowerListData(updatedData);
      } else {
        setUserFollowerListData([]);
        setNoData(true);
      }
    } catch (err) {
      console.error("Error fetching followers:", err);
      setError("An error occurred while fetching followers.");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      name: "Profile",
      minWidth: "280px",
      selector: (row) => row.fullName,
      sortable: true,
      cell: (row) => (
        <>
          <img
            className="table_img rounded-circle img-thumbnail me-2"
            src={row.profilePic ? `${MEDIA_URL}/${row.profilePic}` : bookimg1}
            alt="profile"
            width={50}
            height={50}
          />
          {row.fullName}
        </>
      ),
    },
    {
  name: "Username",
  minWidth: "190px",
  selector: (row) => row.username,
  sortable: true,
  cell: (row) => (
    <Link to={`/admin/view-user/${row._id}?tab=basicinfo`} className="text-primary">
      {row.username}
    </Link>
  ),
},
    {
      name: "Email",
      minWidth: "210px",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Followed On",
      minWidth: "180px",
      selector: (row) => row.followedOn,
      sortable: true,
    },
  ];

  const filteredData = userFollowerListData.filter((item) =>
    JSON.stringify(item).toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <React.Fragment>
      <Card>
        <Card.Body className="bookingtable">
          <div className="text-end mb-3">
            <input
              type="text"
              placeholder="Search..."
              className="searchfield"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>

          {loading ? (
            <div className="text-center my-5">
              <Spinner animation="border" variant="primary" role="status" />
              <div className="mt-2">Loading followers...</div>
            </div>
          ) : error ? (
            <Alert variant="danger" className="text-center">{error}</Alert>
          ) : noData ? (
            <div className="text-center text-muted">No followers found.</div>
          ) : (
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              responsive
              className="custom-table"
            />
          )}
        </Card.Body>
      </Card>
    </React.Fragment>
  );
}
